<template>
  <div class="gamefy">
    <!-- Rewards do use section -->
    <div class="gamefy__section">
      <h2>User Points: {{ userPoints }}</h2>
      <b-button
        type="is-primary"
        @click="randomize"
      >
        {{ $t('gamefyRandomize') }}
      </b-button>
    </div>
    <div class="gamefy__section">
      <b-button type="is-primary" @click="addNewRewardDialog">
        {{ $t('gamefyAddNewReward') }}
      </b-button>
      <!-- show rewards in list -->
      <div class="revards-list">
        <div class="revards-list__item" v-for="reward in userRewards" :key="reward.id">
          <span>{{ reward.name }}</span>
          <span>weighted: {{ reward.weighted }}</span>
          <font-awesome-icon icon="trash" @click="removeReward(reward.id)" />
        </div>
      </div>
    </div>

    <div class="gamefy__section">
      <!-- show rewards in list -->
      <div class="revards-list">
        <div class="revards-list__item" v-for="reward in userWinRewards" :key="reward.id">
          <span>{{ reward.name }}</span>
          <font-awesome-icon icon="trash" @click="removeRewardFromListOfWinRewards(reward.id)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'GamefyRandomize',
  computed: {
    ...mapState({
      userRewards: (state) => state.gamefyStore.userRewards,
      userWinRewards: (state) => state.gamefyStore.userWinRewards,
      userPoints: (state) => state.gamefyStore.userPoints,
    }),
  },
  methods: {
    ...mapActions({
      randomReward: 'gamefyStore/randomReward',
      getUserApiKey: 'gamefyStore/getUserApiKey',
      addNewReward: 'gamefyStore/addNewReward',
      removeReward: 'gamefyStore/removeReward',
      removeRewardFromListOfWinRewards: 'gamefyStore/removeRewardFromListOfWinRewards',
    }),
    randomize() {
      this.randomReward();
    },
    async addNewRewardDialog() {
      // show js prompt
      this.$buefy.dialog.prompt({
        message: 'Add name of new reward',
        inputAttrs: {
          type: 'string',
          maxlength: 100,
          minlength: 5,
        },
        trapFocus: true,
        onConfirm: (name) => {
          this.$buefy.dialog.prompt({
            message: 'Napisz wagę nowej nagrody od 1 - 1000, gdzie dla wartości 1 jest najmniejsza szansa na wylosowanie nagrody, a 1000 największa',
            inputAttrs: {
              type: 'number',
              min: 1,
              max: 1000,
            },
            trapFocus: true,
            onConfirm: (weighted) => {
              this.addNewReward({ name, weighted: +weighted });
            },
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gamefy {
  margin-top: 100px;
  width: 100%;
  &__section {
    margin: 20px auto;
  }
}
.revards-list {
  width: 80%;
  margin: 20px auto 0 auto;
  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 10px;
  }
}
</style>
